<template>
    <div class="base-select">
        <select v-model="proxyValue">
            <option
                v-for="option in options"
                :value="option"
                :key="option.id">{{ option.description}}</option>
        </select>
    </div>
</template>

<script>
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props: {
    options: {
      type: Array,
      required: true
    },
    modelValue: {
      type: Object,
      default: null
    }
  },
  setup(props, { emit }) {
    const proxyValue = computed({
      get() {
        return props.modelValue
      },
      set(val) {
        emit('update:modelValue', val)
      }
    })

    return {
      proxyValue
    }
  }
})
</script>

<style lang="scss" scoped>
.base-select {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 5rem;
  border: 1px solid var(--color-grey-200);
  border-radius: 9px;
  overflow: hidden;
}

.base-select::after {
  content: '\25BC';
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5rem;
  height: 5rem;
  background-color: var(--color-grey-200);
  color: white;
  font-size: 1.1rem;
  transition: .25s all ease;
  pointer-events: none;
}

.base-select--is-disabled {
  opacity: .5;
}

.base-select select {
  height: 100%;
  appearance: none;
  outline: 0;
  border: 0;
  box-shadow: none;
  flex: 1;
  padding: var(--measure-quarter);
  padding-right: calc(#{var(--measure-full)} + #{var(--measure-half)});
  color: var(--custom-select-gray);
  background-color: transparent;
  background-image: none;
  cursor: pointer;
}

.base-select select::-ms-expand {
  display: none;
}

</style>
